import React, { useState } from "react";
import { Button, Modal } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const TextWhitTooltip = ({ value, detail }) => {
    const [showTooltipModal, setShowTooltipModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);

    return (
        <div className="d-flex align-items-center gap-2">
            {/* Valor */}
            <span>{value}</span>

            {/* Botón ℹ️ para el tooltip (descripción corta) */}
            {detail.tooltip && (
                <>
                    <Button
                        variant="link"
                        size="sm"
                        className="p-0 text-info"
                        onClick={() => setShowTooltipModal(true)}
                        title="Ver información"
                    >
                        <FontAwesomeIcon icon={faInfoCircle} />
                    </Button>

                    <Modal show={showTooltipModal} onHide={() => setShowTooltipModal(false)} size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title>Información</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div dangerouslySetInnerHTML={{ __html: detail.tooltip }} />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowTooltipModal(false)}>
                                Cerrar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
            )}

            {/* Botón "Ver más" para el modal de detalle */}
            {detail.modal && (
                <>
                    <Button variant="link" size="sm" onClick={() => setShowDetailModal(true)}>
                        Ver más
                    </Button>

                    <Modal size="xl" show={showDetailModal} onHide={() => setShowDetailModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Info. Adicional</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div dangerouslySetInnerHTML={{ __html: detail.modal }} />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
                                Cerrar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
            )}
        </div>
    );
};

export default TextWhitTooltip;